module.exports = __webpack_public_path__ + "media/images/icon__reddit@3x-c552b612e7a872da6c76dee22c738649.png";